import React, { useEffect, useRef, useState } from "react";
import { navData } from "../Data/Header/Navdata";
import styled from "styled-components";
import MenuButton from "../Header/MenuButton";
import Menutool from "../Header/Menutool";
import { NavLink } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { Box, Container } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { ReactComponent as MenuUser } from "../../Assets/Images/Navbar/menuUser.svg";

export default function Header({data}) {
  const theme = useTheme();
  
  const [isOpen, setIsOpen] = useState(false);
  const ref = useRef();
  const tooltipRef = useRef();
  const navigate = useNavigate();

  function handleClick(event) {
    setIsOpen(!isOpen);
    event.preventDefault();
  }
  function handleClickOutside(event) {
    if (
      ref.current &&
      !ref.current.contains(event.target) &&
      !tooltipRef.current.contains(event.target)
    ) {
      setIsOpen(false);
    }
  }

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const MenuWrapper = styled.div`
  align-items: center;
  display: grid;
  gap: 30px;
  grid-template-columns: repeat(6, auto);

  @media (max-width: 1130px) {
    > a {
      display: none;
    }
    grid-template-columns: auto;
    gap: 15px;
  }
  
  @media (max-width: 768px) {
    gap: 10px;
  }
  
  .active {
    background: ${theme.palette.secondary.main};
    border-radius: 10px;
    padding: 10px 15px;
  }

  a {
    text-decoration: none;
  }
`;
const MenuItem = styled.div`
  color: ${theme.palette.header.text};
  display: grid;
  grid-template-columns: 24px auto;
  gap: ${(props) => (props.title ? "12px" : "0px")};
  align-items: center;
  padding: 0px;
  transition: 0.5s ease-out;
  border-radius: 10px;
  justify-items: center;
  font-weight: bold;

  :hover {
    background: ${theme.palette.secondary.main};
    border: 0.5px solid rgba(255, 255, 255, 0.2);
    box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.1);
    border-radius: 10px;
    padding: 5px 8px;
  }
`;
const MenuSymbol = styled.div`
  color: rgba(255, 255, 255, 0.7);
  display: grid;
  grid-template-columns: 24px auto;
  gap: ${(props) => (props.title ? "12px" : "0px")};
  align-items: center;
  padding: 0px;
  ${"" /* margin-bottom: 15px; */}
  transition: 0.5s ease-out;
  border-radius: 10px;
  justify-items: center;
  /* font-style: normal !important; */

  :hover {
    background: ${theme.palette.secondary.main};
    border: 0.5px solid rgba(255, 255, 255, 0.2);
    box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.1);
    border-radius: 10px;
    padding: 10px 15px;
  }

  @media (max-width: 1130px) {
    display: none;
    grid-template-columns: auto;
  }
`;
  return (
    <HeaderWrapper>
      <Box
        sx={{
          backgroundColor: theme.palette.header.main,
        }}
      >
        <Container
          maxWidth="xl"
          sx={{
            backgroundColor: theme.palette.header.main,
          }}
        >
          <Wrapper>
            <NavLink to="/">
            <Box component="div" sx={{maxHeight:'137px'}}>
              <Logo src={data?.logo ? data?.logo : require("../../Assets/Images/Navbar/pawprint-icon.png")}/>
            </Box>
            </NavLink>
            <MenuWrapper>
              {navData.map((item, index) => (
                <NavLink to={item.link} activeclassname="active" key={index}>
                  <MenuItem title={item.title}>
                     {item.icon}
                    {item.title}
                  </MenuItem>
                </NavLink>
              ))}
              <MenuSymbol>
                <div onClick={() => {
                    navigate("/account");
                  }}>

                <MenuUser
                        style={{
                          fill: `${theme.palette.header.text}`,
                          cursor: "pointer",
                        }}
                      />
                </div>
              </MenuSymbol>
            <HamburgerWrapper onClick={(event) => handleClick(event)} ref={ref}>
              <MenuButton
                item={{
                  icon: require("../../Assets/Images/Navbar/hamburger-menu.png"),
                }}
              />
            </HamburgerWrapper>
          </MenuWrapper>
        </Wrapper>
      </Container>
      <div ref={tooltipRef}></div>
      <Menutool isOpen={isOpen} />
      </Box>
    </HeaderWrapper>
  );
}

const HamburgerWrapper = styled.div`
  display: none;
  cursor: pointer;
  padding: 8px;
  border-radius: 8px;
  transition: background-color 0.3s ease;
  
  &:hover {
    background-color: rgba(255, 255, 255, 0.1);
  }
  
  @media (max-width: 1130px) {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  @media (max-width: 768px) {
    padding: 6px;
    width: 24px;
  }

  @media (max-width: 480px) {
    padding: 4px;
    img{
      width: 30px;
    }
  }

  @media (max-width: 375px) {
    padding: 3px;
  }

  @media (max-width: 320px) {
    padding: 2px;
  }
`;

const Wrapper = styled.div`
  width: 100%;
  height: 150px;
  display: grid;
  gap: 10rem;
  grid-template-columns: 10px auto;
  justify-content: space-between;
  align-items: center;
  z-index: 100;
  padding: 0rem 0rem;

  @media (max-width: 1130px) {
    display: grid;
    gap: 50px;
    grid-template-columns: 1fr auto;
    justify-content: space-between;
    height: 120px;
    padding: 0 1rem;
  }
  
  @media (max-width: 768px) {
    gap: 30px;
    height: 100px;
    padding: 0 0.5rem;
  }
  
  @media (max-width: 480px) {
    gap: 20px;
    height: 90px;
    padding: 0 0.25rem;
  }
  
  @media (max-width: 375px) {
    gap: 15px;
    height: 80px;
    padding: 0 0.125rem;
  }
  
  @media (max-width: 320px) {
    gap: 10px;
    height: 70px;
    padding: 0 0.125rem;
  }
`;

const HeaderWrapper = styled.div`
  width: 100%;
  height: 150px;
  position: sticky;
  top: 0;
  align-items: center;
  z-index: 100;
  padding: 0rem 0rem;

  @media (max-width: 1130px) {
    height: 120px;
  }
  
  @media (max-width: 768px) {
    height: 100px;
  }
  
  @media (max-width: 480px) {
    height: 90px;
  }
  
  @media (max-width: 375px) {
    height: 80px;
  }
  
  @media (max-width: 320px) {
    height: 70px;
  }
`;

const Logo = styled.img`
  transition: transform 0.8s;
  height: auto;
  max-height: 137px;
  
  :hover {
    transform: scale(1.03);
  }

  @media (max-width: 1130px) {
    max-height: 100px;
  }
  
  @media (max-width: 768px) {
    max-height: 80px;
  }
  
  @media (max-width: 480px) {
    max-height: 70px;
  }
  
  @media (max-width: 375px) {
    max-height: 60px;
  }

  @media (max-width: 320px) {
    max-height: 50px;
  }
`;
